export default (value = '') => {
    const dom = new DOMParser().parseFromString(value, 'text/html');
    return (dom.body.innerText || '').replace(/\n/g, "")
};
